module.exports = "././img/DLGRMA_name-01.svg";


//////////////////
// WEBPACK FOOTER
// ../assets/img/DLGRMA_name-01.svg
// module id = 774
// module chunks = 0